import { render, staticRenderFns } from "./VCardInfoRow.vue?vue&type=template&id=4d631ae1&"
import script from "./VCardInfoRow.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VCardInfoRow.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VCardInfoRow.vue?vue&type=style&index=0&id=4d631ae1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports